"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEtPageName = exports.eTrackerCode = exports.Etracker = void 0;
var React = require("react");
var Etracker = function (props) {
    React.useEffect(function () {
        if (props.tenant) {
            // @ts-ignore
            window["et_pagename"] = props.pageName;
            // @ts-ignore
            window["et_popto"] = props.popto;
            // @ts-ignore
            window["et_seg2"] = props.language;
            // @ts-ignore
            window["et_basket"] = props.et_basket;
            // @ts-ignore
            window["et_target"] = props.et_target;
            // @ts-ignore
            window["et_tval"] = props.et_tval;
            // @ts-ignore
            window["et_tonr"] = props.et_tonr;
            var script = document.createElement("script");
            script.id = "_etLoader";
            script.src = "https://static.etracker.com/code/e.js";
            script.charset = "UTF-8";
            script.type = "text/javascript";
            script.setAttribute("data-block-cookies", "true");
            script.setAttribute("data-respect-dnt", "true");
            script.setAttribute("data-secure-code", (0, exports.eTrackerCode)(props.tenant));
            // Loading failed
            script.onerror = function () {
                console.error("Can't load etracker! ");
            };
            // append script element to html
            document.body.appendChild(script);
        }
    }, [props.tenant]);
    return React.createElement(React.Fragment, null);
};
exports.Etracker = Etracker;
var eTrackerCode = function (tenant) {
    var etrackerId = "";
    switch (tenant) {
        case "de-did":
            etrackerId = window.location.href.includes("localhost") || window.location.href.includes("dev") || window.location.href.includes("uat") ? "Npmekm" : "hQxK5E";
            break;
        case "ch-eos":
            etrackerId = "Npmf6V";
            break;
        case "be-eos":
            etrackerId = "hQxJjV";
            break;
        case "es-eos":
            etrackerId = "NpmeP3";
            break;
        case "fr-eos":
            etrackerId = "zmKZGE";
            break;
    }
    return etrackerId;
};
exports.eTrackerCode = eTrackerCode;
var setEtPageName = function (page) {
    try {
        // @ts-ignore
        if (typeof _etracker === "object") {
            // @ts-ignore
            et_eC_Wrapper({ et_et: (0, exports.eTrackerCode)(tenant), et_pagename: page });
        }
        else {
            console.log("ETC not loaded!");
        }
    }
    catch (e) {
        console.log("ETC error!", e);
    }
};
exports.setEtPageName = setEtPageName;
//# sourceMappingURL=Etracker.js.map